import React, { useState } from "react";
import { Controller } from "react-hook-form";
import { IoEyeOffOutline } from "react-icons/io5";
import { IoEyeOutline } from "react-icons/io5";
const InputField = ({
  label,
  type = "text",
  value = "",
  onChange,
  error,
  required,
  control,
  name,
  defaultValue = "",
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className={`form__group ${error && "error"}`}>
      <label>
        {label}
        {required && <span>*</span>}
      </label>
      {control ? (
        <Controller
          name={name}
          control={control}
          defaultValue={defaultValue}
          render={({ field }) => (
            <div className="form__input">
              <input
                {...field}
                type={type === "password" && showPassword ? "text" : type}
                value={field.value}
                onChange={field.onChange}
                {...props}
              />
              {type === "password" && (
                <div className="form__password">
                  {showPassword ? (
                    <IoEyeOffOutline
                      onClick={() => setShowPassword(!showPassword)}
                    />
                  ) : (
                    <IoEyeOutline
                      onClick={() => setShowPassword(!showPassword)}
                    />
                  )}
                </div>
              )}
            </div>
          )}
        />
      ) : (
        <div className="form__input">
          <input
            type={type === "password" && showPassword ? "text" : type}
            value={value}
            onChange={onChange}
            required
            {...props}
          />
          {type === "password" && (
            <div className="form__password">
              {showPassword ? (
                <IoEyeOffOutline
                  onClick={() => setShowPassword(!showPassword)}
                />
              ) : (
                <IoEyeOutline onClick={() => setShowPassword(!showPassword)} />
              )}
            </div>
          )}
        </div>
      )}

      {error && <span className="form__error">{error}</span>}
    </div>
  );
};

export default InputField;
